import { useCallback, useContext } from 'react';
import DocumentViewContext from 'providers/DocumentView/DocumentView.context';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { Q_AND_A_SIDES } from 'router/subrouters/DataRoom/models/QAndA';
import ListingContext from '../../../providers/Listing/Listing.context';

// Opens in the preview modal, so the stage's unsaved changes stay put.
const useOpenStageFile = () => {
  const { openNode } = useContext(DocumentViewContext);
  const { dealRoom } = useContext(ListingContext);

  const { _id: dealRoomId, name, userId } = dealRoom || {};

  return useCallback(
    (node: DataRoomNode, siblings?: DataRoomNode[]) =>
      openNode(
        node,
        {
          dataRoomName: name,
          ownerId: userId,
          userSide: Q_AND_A_SIDES.SELL,
          dealRoomId,
        },
        siblings,
      ),
    [dealRoomId, name, openNode, userId],
  );
};

export default useOpenStageFile;
